import theme from '../../themes/green';

const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    flex: '1',
  },
  track: {
    width: 10,
    top: 0,
    right: 0,
    bottom: 0,
  },
  thumb: {
    background: theme.pallete.scrollbar,
  },
  accessoryButton: {
    borderRadius: '50%',
    minWidth: 'inherit',
    background: 'transparent',
    opacity: 1,
    marginHorizontal: 10,
    padding: 0,
    fontSize: 16,
    width: 17,
    height: 17,
    ':hover': {
      background: 'transparent',
      opacity: 0.6,
    },
  },
  accessoryButtonActive: {
    color: theme.pallete.lightBackground,
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/LayersPanel/styles.js